import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js/auto'
import { useTranslation } from 'react-i18next'

const Courbe = ({ poi }) => {
  const { t } = useTranslation()
  const chartRef = useRef()
  const chartInstance = useRef(null)

  const shouldRender = poi && poi.altiDatas && poi.altiDatas.length > 0

  useEffect(() => {
    if (shouldRender) {
      const coordinates = poi.altiDatas.map((point) => ({
        x: point[0] / 1000,
        y: point[1],
      }))
      const ctx = chartRef.current.getContext('2d')

      const maxX = Math.max(...poi.altiDatas.map((point) => point[0] / 1000))
      const maxAltitude = Math.max(...poi.altiDatas.map((point) => point[1]))
      const maxY = Math.ceil(maxAltitude / 100) * 100 + 100

      if (chartInstance.current !== null) {
        chartInstance.current.destroy()
      }

      const gradient = ctx.createLinearGradient(
        0,
        0,
        0,
        chartRef.current.clientHeight,
      )
      gradient.addColorStop(0, 'rgba(1, 75, 1, 0)')
      gradient.addColorStop(1, 'rgba(1, 75, 1, 0.1)')

      chartInstance.current = new Chart(ctx, {
        type: 'line',
        data: {
          datasets: [
            {
              data: coordinates,
              fill: true,
              backgroundColor: gradient,
              borderColor: '#014b01',
              tension: 0.1,
            },
          ],
        },
        options: {
          scales: {
            x: {
              type: 'linear',
              position: 'bottom',
              max: maxX,
            },
            y: {
              type: 'linear',
              beginAtZero: true,
              suggestedMax: maxY,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          elements: {
            point: {
              radius: 0,
            },
          },
        },
      })
    }
  }, [poi, shouldRender])

  if (!shouldRender) {
    return null
  }

  return (
    <div>
      <hr />
      <h2>{t('ALTITUDE_PROFILE')}</h2>
      <div>
        <canvas ref={chartRef} />
      </div>
    </div>
  )
}

export default Courbe
